import { useEffect } from 'react';
import * as Yup from 'yup';

import { Form } from 'react-bootstrap';
import { useFormik } from 'formik';
import { useAppDispatch, useAppSelector } from '../../../../store/hooks';
import {
  AddUserRole,
  DeleteUserRole,
  GetRoleByUserId,
  GetRoleList,
} from '../../../../store/NTX/Security/Rules/RulesSlice';
import CustomAlert from '../../../../components/Shared/Alert/CustomAlert';
import { useTranslation } from 'react-i18next';
import showConfirmation from '../../../../components/Shared/Alert/Confirmation';
import NtxTable from '../../../../components/DataTable/NtxTable';
import Loading from '../../../../components/Shared/Loader/Loading';

const RulesUser = ({ userId }: { userId: string }) => {
  const { t, i18n } = useTranslation();
  const dispatch = useAppDispatch();

  const { RoleByUserIdList, RulesList, loading, error } = useAppSelector((state) => state.Rules);

  useEffect(() => {
    if (RulesList?.length === 0) {
      dispatch(GetRoleList());
    }
    if (userId) {
      dispatch(GetRoleByUserId(userId));
    }
  }, [dispatch, userId]);

 

  const formik = useFormik({
    initialValues: {
      userId: '',
      ruleId: '',
    },

    validationSchema: Yup.object().shape({
      ruleId: Yup.string()
        .notOneOf(['إختر', 'Choose'], 'Required')
        .required(() => t('Required')),
    }),
    onSubmit: (values) => {
      dispatch(
        AddUserRole({
          userId: userId,
          roleId: values.ruleId,
        })
      )
        .unwrap()
        .then((res) => {
          if (res.succeeded === true) {
            formik.resetForm();
            CustomAlert({ action: 'Add' });
            dispatch(GetRoleByUserId(userId || ''));
          } else {
            CustomAlert({ action: 'Error' });
          }
        })
        .catch((error) => {
          console.log(error);
          CustomAlert({ action: 'Error' });
          formik.setSubmitting(false);
        });
    },
  });

  //_______________

  const columns = [
    { title: t('Name'), key: 'Name' },
    { title: t('Start Date'), key: 'Start' },
    { title: t('End_Date'), key: 'End' },
    { title: t(''), key: 'action', className: 'text-end  ' },
  ];

  const tableData = RoleByUserIdList?.map((item) => {
    let rowClass;

    return {
      Name: i18n.language === 'en' ? item.name : item.name2,
      Start: item.startDate,
      End: item.endDate,

      action: (
        <button
          type="button"
          className="btn btn-outline-danger m-0"
          onClick={() => handleDeleteUserRule(item.id)}>
          <i className="fas fa-trash-alt fa-fw fa-lg"></i>
        </button>
      ),

      rowClass, // استخدم rowClass هنا
    };
  });
  //_______________

  const handleDeleteUserRule = (id: any) => {
    showConfirmation(t('MsgConfirm'), () => {
      dispatch(DeleteUserRole({ roleId: id, userId: userId }))
        .unwrap()
        .then((res) => {
          if (res?.succeeded) {
            CustomAlert({ action: 'Delete' });
            dispatch(GetRoleByUserId(userId || ''));
          } else {
            CustomAlert({ action: 'Error' });
          }
        })
        .catch((error) => {
          console.log(error);
          CustomAlert({ action: 'Error' });
        });
    });
  };

  return (
    <>
      <Loading loading={loading} error={error} Type="Dots">
        <Form onSubmit={formik.handleSubmit}>
          <div className="row align-items-end">
            <div className="col-xl-8 ">
              <div className="form-group mb-2">
                <label className="form-label">{t('RulesPermissions')}</label>
                <Form.Select
                  className="form-select"
                  name="ruleId"
                  onChange={formik.handleChange}
                  value={formik.values.ruleId}
                  isInvalid={!!(formik.touched.ruleId && formik.errors.ruleId)}>
                  <option value={''}>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
                  {RulesList &&
                    RulesList?.map((item, idx) => (
                      <option key={++idx} value={item.id}>
                        {i18n.language === 'ar' ? item.name2 : item.name}
                      </option>
                    ))}
                </Form.Select>
                <Form.Control.Feedback type="invalid">{formik.errors.ruleId}</Form.Control.Feedback>
              </div>
            </div>

            <div className="col-xl-4 text-end ">
              <div className=" form-group mb-2 d-flex justify-content-end ">
                <button
                  disabled={formik.isSubmitting}
                  type="submit"
                  className="btn me-1 btn-theme w-50">
                  {formik.isSubmitting ? (
                    <div className="spinner-border spinner-border-sm me-2"></div>
                  ) : (
                    <i className="fas fa-lg fa-fw me-2 fa-plus"></i>
                  )}
                  {t('Add')}
                </button>
                <button
                  type="button"
                  className=" btn me-1 btn-default w-50"
                  data-bs-dismiss="modal">
                  <i className="fa fa-power-off fa-fw me-1"></i> {t('Cancel')}
                </button>
              </div>
            </div>
          </div>
        </Form>

        <NtxTable
          data={tableData || []}
          columns={columns}
          dataPerPage={5}
          theadClass=""
          tableClass="table text-nowrap table-hover "
          // enableSearch
          // showRecordsSelector
        />
      </Loading>
    </>
  );
};

export default RulesUser;
